module.exports = __webpack_public_path__ + "static/media/donation-white.2994ab3c.webp";